import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";

/* =========================================================
 * ユーザー詳細取得 (User Detail Fetch)
 * ========================================================= */
export const fetchUserDetailRequest = () => ({
  type: ActionTypes.FETCH_USER_DETAIL_REQUEST,
});

export const fetchUserDetailSuccess = (detail) => ({
  type: ActionTypes.FETCH_USER_DETAIL_SUCCESS,
  payload: detail,
});

export const fetchUserDetailFailure = (error) => ({
  type: ActionTypes.FETCH_USER_DETAIL_FAILURE,
  payload: error,
  error: true,
});

export const fetchUserDetail = (userId) => async (dispatch) => {
  dispatch(fetchUserDetailRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.get(
      `${BASE_URL}?path=user&type=get-data&id=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const detail = response.data.respons;

    dispatch(fetchUserDetailSuccess(detail));

    return { payload: detail };
  } catch (error) {
    dispatch(fetchUserDetailFailure(error.message));
    return { error: error.message };
  }
};

/* =========================================================
 * ユーザー編集 (User Update)
 * ========================================================= */
export const fetchUserUpdateRequest = () => ({
  type: ActionTypes.FETCH_USER_UPDATE_REQUEST,
});

export const fetchUserUpdateSuccess = (data) => ({
  type: ActionTypes.FETCH_USER_UPDATE_SUCCESS,
  payload: data,
});

export const fetchUserUpdateFailure = (data) => ({
  type: ActionTypes.FETCH_USER_UPDATE_FAILURE,
  payload: data,
});

export const updateUser = (payload) => async (dispatch) => {
  dispatch(fetchUserUpdateRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.post(
      `${BASE_URL}?path=user&type=update-info-data`,
      payload,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.respons || "更新に失敗しました。");
    }

    // SUCCESS
    dispatch(fetchUserUpdateSuccess(response.data.respons));
    return { payload: response.data.respons };

  } catch (error) {
    // FAIL
    const errorMsg = error.response?.data?.respons || error.message;
    dispatch(fetchUserUpdateFailure(errorMsg));
    return { error: errorMsg };
  }
};